module.exports = __webpack_public_path__ + "img/X1Medicaltochnologies.b9682c12.png";